"use client"

import clsx from "clsx"
import { motion, AnimatePresence } from "framer-motion"
import type { Variants } from "framer-motion"
import React, { useContext } from "react"

import BackIcon from "../../../../../public/icons/arrow-left.svg"
import PageThemeContext from "../../page-theme/PageThemeContext"
import PageGrid from "../../PageGrid"
import type { NavItem } from "../types/navigation"

import SubmenuMobile from "./SubmenuMobile"

interface IMenuMobileProps {
  activeMenuOpen: boolean
  activeMenuName: string | undefined
  setActiveMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
  menuData: NavItem[]
}

const MenuMobile: React.FC<IMenuMobileProps> = ({
  activeMenuOpen,
  activeMenuName,
  setActiveMenuOpen,
  menuData,
}) => {
  const pageThemeContext = useContext(PageThemeContext)
  const navItemColorClass = pageThemeContext.pageTheme.dark
    ? "text-gray-2.5"
    : "text-gray-90"
  const SlideInMenuVariants: Variants = {
    open: {
      opacity: 1,
      x: "0%",
      transition: {
        type: "spring",
        bounce: 0,
      },
    },
    closed: {
      opacity: 0,
      x: "100%",
      transition: {
        type: "spring",
        bounce: 0,
      },
    },
  }

  const SubmenuFadeInVariants: Variants = {
    open: {
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    closed: {
      transition: {
        when: "afterChildren",
        staggerChildren: 0.1,
        staggerDirection: -1,
      },
    },
  }

  return (
    <AnimatePresence>
      {activeMenuOpen && (
        <motion.div
          key="ActiveMenu"
          variants={SlideInMenuVariants}
          animate={activeMenuOpen ? "open" : "closed"}
          initial="closed"
          exit="closed"
          className={clsx(
            "absolute top-0 z-10 w-full h-full",
            pageThemeContext.pageTheme.bgColorClass,
          )}
        >
          <PageGrid>
            <div className="flex justify-between px-4 mt-4 mb-8 md:mt-2 col-span-full md:mb-10">
              <button
                type="button"
                onClick={() => setActiveMenuOpen(null)}
                className={clsx(
                  "flex items-center p-0 md:py-4",
                  navItemColorClass,
                )}
              >
                <BackIcon className={clsx("mr-2", navItemColorClass)} />
                Back
              </button>
              <div className={clsx("p-0 md:py-4", navItemColorClass)}>
                {activeMenuName}
              </div>
            </div>
            {/* sections go here */}
            {menuData
              .filter(
                (menuitem) =>
                  menuitem.name.toLowerCase() === activeMenuName?.toLowerCase(),
              )
              .map((filteredMenuitem) =>
                filteredMenuitem.sections.map((section) => (
                  <SubmenuMobile
                    variants={SubmenuFadeInVariants}
                    {...section}
                    key={section.heading}
                  />
                )),
              )}
          </PageGrid>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default MenuMobile
